import React from "react";
import { Row, Col, Button } from "@folio/stripes/components";
import { useIntl } from "react-intl";
export var ExpandCollapseToggle = function (_a) {
    var expanded = _a.expanded, onToggle = _a.onToggle;
    var formatMessage = useIntl().formatMessage;
    return (React.createElement(Row, null,
        React.createElement(Col, { xs: 12, style: { display: "flex", justifyContent: "flex-end" } },
            React.createElement(Button, { onClick: onToggle, buttonStyle: "default" }, expanded
                ? formatMessage({ id: "ui-br-agency.button.collapse" })
                : formatMessage({ id: "ui-br-agency.button.expand" })))));
};
